import React, { useEffect, useState } from 'react';
import {
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  Paper,
  Switch,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import ActionButton from '../../../components/ActionButton';
import CustomSnackbar from '../../../components/CustomSnackbar';

const useStyles = makeStyles((theme) => ({
  paper: {
    width: '100%',
    padding: theme.spacing(4, 8),
    boxSizing: 'border-box',
  },
  formControlLabel: {
    margin: theme.spacing(1.5, 0),
  },
  switchRow: {
    columnGap: theme.spacing(16),
  },
  formLabel: {
    marginBottom: theme.spacing(3),
    color: theme.palette.primary.main,
    fontWeight: 600,
    fontSize: '1.1rem',
  },
  buttonContainer: {
    marginTop: theme.spacing(5),
    textAlign: 'right',
  },
}));

const SwitchSection = ({
  notificheAggregate,
  multiselect,
  onChange,
  disabledForm,
  onSave,
  showSaveButton = false,
  loadingDatiEsercizio,
  isLoadingGestioneOperativa,
  checkboxSaveSuccess,
}) => {
  const classes = useStyles();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
  });

  const handleOpenSnackbar = (message) => {
    setSnackbar({ open: true, message });
  };

  useEffect(() => {
    if (checkboxSaveSuccess) {
      handleOpenSnackbar('Impostazioni salvate con successo');
    }
  }, [checkboxSaveSuccess]);

  const handleCloseSnackbar = () => {
    setSnackbar({ open: false, message: '' });
  };

  return (
    <>
      <Paper className={classes.paper}>
        <Grid container direction="column">
          <FormControl component="fieldset">
            <FormLabel className={classes.formLabel}>
              Impostazioni App mobile
            </FormLabel>
            <FormGroup row className={classes.switchRow}>
              <FormControlLabel
                className={classes.formControlLabel}
                control={
                  <Switch
                    name="notificheAggregate"
                    checked={notificheAggregate}
                    onChange={onChange}
                    color="primary"
                    disabled={disabledForm}
                  />
                }
                label={
                  <Typography variant="body2">
                    Invio di notifiche push aggregate
                  </Typography>
                }
              />
              <FormControlLabel
                className={classes.formControlLabel}
                control={
                  <Switch
                    name="multiselect"
                    checked={multiselect}
                    onChange={onChange}
                    color="primary"
                    disabled={disabledForm}
                  />
                }
                label={
                  <Typography variant="body2">
                    Multiselect sui controlli da validare
                  </Typography>
                }
              />
            </FormGroup>
          </FormControl>
          {showSaveButton && (
            <Grid item className={classes.buttonContainer}>
              <ActionButton
                label="Salva impostazioni"
                onClick={onSave}
                disabled={loadingDatiEsercizio || isLoadingGestioneOperativa}
              />
            </Grid>
          )}
        </Grid>
      </Paper>
      <CustomSnackbar
        open={snackbar.open}
        onClose={handleCloseSnackbar}
        message={snackbar.message}
      />
    </>
  );
};

SwitchSection.propTypes = {
  checkboxSaveSuccess: PropTypes.bool,
  disabledForm: PropTypes.bool.isRequired,
  multiselect: PropTypes.bool.isRequired,
  notificheAggregate: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  showSaveButton: PropTypes.bool,
  loadingDatiEsercizio: PropTypes.bool,
  isLoadingGestioneOperativa: PropTypes.bool,
};

export default SwitchSection;
